import { ErrorState } from './types';

export const getErrorTitle = (state: ErrorState) => state.error.title;
export const getErrorText = (state: ErrorState) => state.error.text;
export const getErrorButtons = (state: ErrorState) => state.error.buttons;
export const getErrorIcon = (state: ErrorState) => state.error.icon;

